import { EntityTypeEnum } from '../enums/entity-type.enum';
import { IStudent } from '../interfaces/users/student.interface';
import { IUser } from '../interfaces/users/user.interface';

export const mockStudent: IStudent[] = [
    {
        id: 3,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Doe',
        firstname: 'John',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.STUDENT,
        birthdate: new Date(),
        schoolId: 1,
        classId: 1,
        nationalNumber: '98.02.08-346.31',
        rateType: { id: 1, type: 'normal', name: 'normal' },
        discount: 1,
        addresses: {
            parentOne: {
                street: 'rue de la poste',
                home_number: '5',
                box: '',
                additional_information: '',
                postal_code: '4000',
                city: 'Liège',
                country: 'Belgique',
            },
        },
        parentsIds: [2],
        relativeIds: [2],
        settings: null,
        accessLevel: 5,
        educationLevel: [{ id: 1, type: 'primary', name: 'primaire' }],
        qrCodePath: 'test',
        preferredAddressId: 1,
    },
];

export const mockUsers: IUser[] = [
    {
        id: 1,
        gender: { id: 1, type: 'm', name: 'homme' },
        lastname: 'admin1',
        firstname: 'admin1',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.EMPLOYEE,
        displayName: 'admin1',
        email: 'admin1@itw.be',
        mobileNumber: '0032487226635',
        homeNumber: '042336698',
        address: {
            street: 'rue de la poste',
            home_number: '1',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Liège',
            country: 'Belgique',
        },
        role: [
            { id: 1, type: 'administrator', name: 'administrateur' },
            { id: 8, type: 'parent', name: 'parent' },
        ],
        educationLevel: [
            { id: 1, type: 'primary', name: 'primaire' },
            { id: 1, type: 'kindergarten', name: 'maternelle' },
        ],
        schoolIds: [1],
        settings: {
            notification: true,
            msg_copy_by_mail: false,
        },
    },
    {
        id: 2,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Doe',
        firstname: 'Jane',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.PARENT,
        email: 'parent1@itw.be',
        mobileNumber: '0032487226635',
        homeNumber: '042336698',
        nationalNumber: '00.11.22-592.52',
        address: {
            street: 'rue de la poste',
            home_number: '5',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Liège',
            country: 'Belgique',
        },
        role: [{ id: 8, type: 'parent', name: 'parent' }],
        childrenIds: [3],
        settings: {
            notification: true,
            msg_copy_by_mail: false,
        },
    },
    {
        id: 3,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Cardin',
        firstname: 'Marcel',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.STUDENT,
        birthdate: new Date(),
        schoolId: 2,
        classId: 2001,
        nationalNumber: '98.02.08-346.31',
        rateType: { id: 1, type: 'normal', name: 'normal' },
        discount: 1,
        addresses: {
            parentOne: {
                street: 'rue de la poste',
                home_number: '5',
                box: '',
                additional_information: '',
                postal_code: '4000',
                city: 'Liège',
                country: 'Belgique',
            },
        },
        parentsIds: [2],
        relativeIds: [2],
        settings: {
            costsRepartition: null,
        },
    },
    {
        id: 4,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Heinkel',
        firstname: 'Pierre',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.STUDENT,
        birthdate: new Date(),
        schoolId: 1,
        classId: 2001,
        nationalNumber: '98.02.08-346.31',
        rateType: { id: 1, type: 'normal', name: 'normal' },
        discount: 1,
        addresses: {
            parentOne: {
                street: 'rue de la poste',
                home_number: '5',
                box: '',
                additional_information: '',
                postal_code: '4000',
                city: 'Liège',
                country: 'Belgique',
            },
        },
        parentsIds: [2],
        relativeIds: [2],
        settings: {
            costsRepartition: null,
        },
    },
    {
        id: 5,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Dongelberg',
        firstname: 'Tina',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.STUDENT,
        birthdate: new Date(),
        schoolId: 2,
        classId: 2001,
        nationalNumber: '98.02.08-346.31',
        rateType: { id: 1, type: 'normal', name: 'normal' },
        discount: 1,
        addresses: {
            parentOne: {
                street: 'rue de la poste',
                home_number: '5',
                box: '',
                additional_information: '',
                postal_code: '4000',
                city: 'Liège',
                country: 'Belgique',
            },
        },
        parentsIds: [2],
        relativeIds: [2],
        settings: {
            costsRepartition: null,
        },
    },
    {
        id: 6,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Doe',
        firstname: 'John',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.STUDENT,
        birthdate: new Date(),
        schoolId: 1,
        classId: 2001,
        nationalNumber: '98.02.08-346.31',
        rateType: { id: 1, type: 'normal', name: 'normal' },
        discount: 1,
        addresses: {
            parentOne: {
                street: 'rue de la poste',
                home_number: '5',
                box: '',
                additional_information: '',
                postal_code: '4000',
                city: 'Liège',
                country: 'Belgique',
            },
        },
        parentsIds: [2],
        relativeIds: [2],
        settings: {
            costsRepartition: null,
        },
    },
    {
        id: 7,
        gender: { id: 1, type: 'm', name: 'homme' },
        lastname: 'Desbois',
        firstname: 'Robin',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.EMPLOYEE,
        email: 'robin@itw.be',
        mobileNumber: '0032487226635',
        homeNumber: '042336698',
        nationalNumber: '00.11.22-592.52',
        address: {
            street: 'Dans les bois',
            home_number: '5',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Herve',
            country: 'Belgique',
        },
        role: [{ id: 1, type: 'administrator', name: 'administrateur' }],
        schoolIds: [2],
        settings: {
            notification: true,
            msg_copy_by_mail: false,
        },
    },
    {
        id: 8,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'De Neuw',
        firstname: 'Pol',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.PARENT,
        email: 'parent1@itw.be',
        mobileNumber: '0032487226635',
        homeNumber: '042336698',
        nationalNumber: '00.11.22-592.52',
        address: {
            street: 'rue de la poste',
            home_number: '5',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Liège',
            country: 'Belgique',
        },
        role: [{ id: 8, type: 'parent', name: 'parent' }],
        childrenIds: [3],
        settings: {
            notification: true,
            msg_copy_by_mail: false,
        },
    },
    {
        id: 9,
        gender: { id: 2, type: 'f', name: 'femme' },
        lastname: 'Everard',
        firstname: 'Simone',
        lang: 'fr',
        isActive: true,
        type: EntityTypeEnum.PARENT,
        email: 'parent1@itw.be',
        mobileNumber: '0032487226635',
        homeNumber: '042336698',
        nationalNumber: '00.11.22-592.52',
        address: {
            street: 'rue de la poste',
            home_number: '5',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Liège',
            country: 'Belgique',
        },
        role: [{ id: 8, type: 'parent', name: 'parent' }],
        childrenIds: [3],
        settings: {
            notification: true,
            msg_copy_by_mail: false,
        },
    },
];
